import vue from 'vue/dist/vue';
import Vue from 'vue/dist/vue';
Vue.component('vue-select', require('vue-select').default)
Vue.component('modal', require('./Modal.vue'))
Vue.component('prompt', require('./Prompt.vue'))
Vue.component('user-form', require('./user/user_form.vue'))
Vue.component('select2', require('./multiselect2.vue'))
Vue.component('role-form', require('./role.vue'))
Vue.component('edit-service-form', require('./service_form').default)
Vue.component('vue-datepicker', require('vue2-datepicker').default)
Vue.component('owner-type-selector', require('./owner-type-selector'))
Vue.component('service-bank-config', require('./admin/ServiceBankConfig.vue'))
Vue.component('account-balance', require('./admin/AccountBalance.vue'))
Vue.component('admin-accounts', require('./admin/AdminAccounts.vue'))

//Agency components
Vue.component('agent-float-balance', require('./agency/AgentFloatBalance.vue'))
Vue.component('agent-dashboard', require('./agency/AgentDashboard.vue'))
Vue.component('agent-money-tools', require('./agency/DWComponent.vue'))
Vue.component('agent-revenue-30day-chart', require('./agency/RevenueChart.vue'))
Vue.component(
    'agent-customer-30day-chart',
    require('./agency/CustomerChart.vue'),
)
Vue.component('customer-modal', require('./agency/CustomerModal.vue'))
Vue.component('bank-account-modal', require('./agency/BankAccountModal.vue'))
Vue.component(
    'add-agent-service-modal',
    require('./agency/AddAgentServiceModal.vue'),
)
Vue.component(
    'customer-service-invoice-modal',
    require('./agency/CustomerServiceInvoiceModal.vue'),
)
Vue.component('change-pwd-modal', require('./agency/ChangePwdModal.vue'))
Vue.component('change-pin-modal', require('./agency/ChangePin.vue'))

Vue.component('withdrawals-list', {
    props: ['date-range'],
    data() {
        return {
            date_range: null,
        }
    },
    computed: {
        current_range() {
            if (this.date_range && this.date_range[0] && this.date_range[1]) {
                return this.date_range.join(' - ')
            }
            return ''
        },
    },
    mounted() {
        if (this.dateRange) {
            this.date_range = this.dateRange.split(' - ')
        }
    },
    methods: {
        applyFilter() {
            this.$nextTick(() => {
                document.getElementById('filter-form').submit()
            })
        },
    },
})

Vue.component('ledgers-list', {
    props: ['date-range'],
    data() {
        return {
            date_range: null,
        }
    },
    computed: {
        current_range() {
            if (this.date_range && this.date_range[0] && this.date_range[1]) {
                return this.date_range.join(' - ')
            }
            return ''
        },
    },
    mounted() {
        if (this.dateRange) {
            this.date_range = this.dateRange.split(' - ')
        }
    },
    methods: {
        applyFilter() {
            this.$nextTick(() => {
                document.getElementById('filter-form').submit()
            })
        },
    },
})

Vue.component('transactions-list', {
    props: ['date-range'],
    data() {
        return {
            date_range: null,
        }
    },
    computed: {
        current_range() {
            if (this.date_range && this.date_range[0] && this.date_range[1]) {
                return this.date_range.join(' - ')
            }
            return ''
        },
    },
    mounted() {
        if (this.dateRange) {
            this.date_range = this.dateRange.split(' - ')
        }
    },
    methods: {
        applyFilter() {
            this.$nextTick(() => {
                document.getElementById('filter-form').submit()
            })
        },
    },
})

Vue.component('self-signup', require('./agency/SelfSignUp.vue'))
Vue.component('topup-button', require('./iframev2/Topup.vue'))
Vue.component('pay-from-account-button', require('./iframev2/Pay.vue'))
Vue.component('complete-button', require('./iframev2/Complete.vue'))
Vue.component('mpesa-v2', require('./iframev2/MpesaV2.vue'))
Vue.component('absa-v2', require('./iframev2/AbsaV2.vue'))
Vue.component('selcom-v2', require('./iframev2/SelcomV2.vue'))
Vue.component('crdb-v2', require('./iframev2/CRDBV2.vue'))
Vue.component('card-v2', require('./iframev2/CardV2.vue'))
Vue.component('card-v3', require('./iframev2/CardV3.vue'))
Vue.component('eazzypay-v2', require('./iframev2/EazzypayV2.vue'))
Vue.component('airtel-v2', require('./iframev2/AirtelmoneyV2.vue'))
Vue.component('tkash', require('./iframev2/Tkash.vue'))
Vue.component('airtel-v3', require('./iframev2/AirtelmoneyV3.vue'))
Vue.component('kcbcash-v2', require('./iframev2/KcbcashV2.vue'))
Vue.component('kcb-mpesa', require('./iframev2/Kcbmpesa.vue'))
Vue.component('equitycash-v2', require('./iframev2/EquitycashV2.vue'))
Vue.component('pesalink-v2', require('./iframev2/PesalinkV2.vue'))
Vue.component('capitalpay-v2', require('./iframev2/CapitalPayV2.vue'))
Vue.component('pesaflow-account-v2', require('./iframev2/PesaflowInternal.vue'))
Vue.component('payment-instructions', require('./iframev2/PaymentInstructions.vue'))
Vue.component('fdh-bank-gateway', require('./iframev2/FDH.vue'))
Vue.component('orangemoney-v2', require('./iframev2/OrangeMoneyV2.vue'))
Vue.component('afrimoney-v2', require('./iframev2/AfriMoneyV2.vue'))
Vue.component('uba-v2', require('./iframev2/UBAV2.vue'))
Vue.component('equitycheckout', require('./iframev2/EquityCheckout.vue'))
Vue.component('ecocash', require('./iframev2/EcoCash.vue'))
Vue.component('cybersource', require('./iframev2/Cybersource.vue'))
Vue.component('airtel-v2', require('./iframev2/AirtelV2.vue'))
Vue.component('mpamba-v2', require('./iframev2/MpambaV2.vue'))
Vue.component('recon-form', require('./recon/recon_form.vue'))
Vue.component(
    'agency-rev-share-form',
    require('./agency/AgencyServiceRevShare.vue'),
)
Vue.component(
    'business-metadata-form',
    require('./agency/BusinessMetadataForm.Vue'),
)
Vue.component('unionpay-v2', require('./iframev2/UnionpayV2.vue'))
Vue.component('admin-dashboard', require('./admin/AdminDashboard.vue'))
Vue.component('revenue-all-time', require('./admin/RevenueAllTime.vue'))
Vue.component('revenue-this-year', require('./admin/RevenueThisYear.vue'))
Vue.component('revenue-this-month', require('./admin/RevenueThisMonth.vue'))
Vue.component('revenue-today', require('./admin/RevenueToday.vue'))
Vue.component(
    'admin-service-leader-board',
    require('./admin/AdminServiceLeaderBoard.vue'),
)
Vue.component(
    'admin-applications-per-gateway',
    require('./admin/AdminApplicationsPerGateway.vue'),
)
Vue.component(
    'admin-applications-customer-revenue',
    require('./admin/AdminApplicationCustomersRevenue.vue'),
)
Vue.component(
    'admin-invoice-tracker',
    require('./admin/AdminInvoiceTracker.vue'),
)
Vue.component('pesaflow-gateway', require('./iframev2/Pesaflow.vue'))
Vue.component('withdrawal-tool', require('./shared/WithdrawalTool.vue'))
Vue.component(
    'payment-notification-reset-modal',
    require('./admin/AdminPaymentNotificationsReset.vue'),
)
Vue.component(
    'service-rev-share-form',
    require('./admin/AdminServicesRevShare.vue'),
)
Vue.component(
    'admin-create-account-form',
    require('./admin/AdminAccountModalForms.vue'),
)
Vue.component('self-signup-wizard', require('./web/SelfSignUpWizard.vue'))
Vue.component('business-signup-wizard', require('./web/SelfSignUpBusinessWizard.vue'))
Vue.component('excel-exporter', require('./shared/excel-exporter.vue'))
//Vue.component('business-signup-wizard', require('./web/business_signup.vue'))
//merchant
Vue.component('merchant-invoice-create-form', require('./merchant/InvoiceCreateForm.vue'))
Vue.component('service-invoice-template-form', require('./admin/ServiceInvoiceTemplateForm.vue'))
Vue.component('mark-as-used-button', require('./admin/AdminMarkInvoiceAsUsedButton.vue'))
Vue.component('login-form', require('./user/login.vue'))
Vue.component('new-login-form', require('./user/loginV2.vue'))
Vue.component('TimerComponent', require('./user/TimerComponent.vue'))
Vue.component('lazy-load-list', require('./admin/AdminLazyLoadList.vue'))

//Vue.component('lazy-loaded-invoice', require('./shared/invoices.vue'))

Vue.component('payment-gateway-form', require('./payment_gateway_form').default)

//settlement dashboard
Vue.component('settlement-dashboard', require('./admin/SettlementDashboard.vue'))
Vue.component('settlement-details', require('./admin/SettlementDetails.vue'))
Vue.component('settlement-modal', require('./shared/SettlementModal.vue'))
Vue.component('agency-dashboard', require('./admin/AgencyDashboard.vue'))
Vue.component("agency-revenue-30day-chart", require('./agency/AgencyRevenue.vue'));
Vue.component("agency-customer-30day-chart", require('./agency/AgencyCustomers.vue'));
Vue.component("service-form", require('./admin/ServiceForm.vue'))
Vue.component('batch-withdraw-form', require('./admin/BatchWithdrawForm.vue'))
Vue.component('manual-recon', require('./admin/ManualRecon.vue'))
Vue.component('download-report', require('./admin/DownloadReport.vue'))
Vue.component('device-data-collection', require('./iframev2/DeviceDataCollection.vue'))
Vue.component('bulk-fetch-template', require('./admin/BulkFetchTemplate.vue'))
Vue.component('maker-checker', require('./admin/MakerChecker.vue'))
Vue.component('show-task', require('./admin/ShowTask.vue'))

Vue.component('payment-date-picker', {
    props: ['daterange'],
    data() {
        return {
            date_range: null,
        }
    },
    computed: {
        current_range() {
            return this.date_range;
        },
        
    },
    mounted() {
        this.date_range = this.daterange;
    },
    methods: {
        disableFutureDates(date) {
            return date > new Date();
        },
        applyFilter() {
            this.$nextTick(() => {
                var gateway = $("#gateway").val();
                var ref_no = $("#ref_no").val();
                var name = $("#name").val();
                var source = $("#source").val();
                var amount = $("#amount").val();
                var type = $("#type").val();
                var date = $("#payment_date").val();
                var gateway_transaction_id = $("#gateway_transaction_id").val();

                window.top.location.href = "/payments/new?query[gateway]=" + gateway + "&query[name]=" + name + "&query[gateway_transaction_date]=" + date + "&query[gateway_transaction_id]=" + gateway_transaction_id + "&query[ref_no]=" + ref_no + "&query[amount]=" + amount + "&query[source]=" + source + "&query[type]=" + type + "&query[notification_attachment]=";

            })
        },
    },
})

Vue.component('invoice-date-picker', {
    props: ['daterange'],
    data() {
        return {
            date_range: null,
            }
        },
    computed: {
        current_range() {
            return this.date_range;
        }
    },
    mounted() {
        this.date_range = this.daterange;
    },
    methods: {
        disableFutureDates(date) {
            return date > new Date();
        },
        applyFilter() {
            this.$nextTick(() => {
                window.top.location.href = "/invoices?query[date_range]=" + this.date_range;
            })
        }

    }

})
Vue.component('gateway-order-config', require('./admin/GatewayOrderConfig.vue'));
Vue.component('transaction-status-component', require('./iframev2/TransactionStatusComponent.vue'));
